import { render, staticRenderFns } from "./AddCtc.vue?vue&type=template&id=5ab2d5b0&scoped=true"
import script from "./AddCtc.vue?vue&type=script&lang=js"
export * from "./AddCtc.vue?vue&type=script&lang=js"
import style0 from "./AddCtc.vue?vue&type=style&index=0&id=5ab2d5b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab2d5b0",
  null
  
)

export default component.exports